/* eslint-disable max-lines */
//TODO: Refactor max-lines
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { ProfileSelectorFacadeService } from '@com-delta-idp/mnx-capability-profile-selector-smart';
import { takeUntil } from 'rxjs/operators';
import { LoginDasboardService } from '../../data-access/login-modal/services/login-dasboard.service';
import { LoginModalService } from '../../data-access/login-modal/services/login-modal.service';
import { CoreUtilService } from '../../data-access/utils/core-util.service';
import { LoginHelperUtils } from '../../data-access/utils/login-helper.utils';
import { LoginModalWrapperHelperComponent } from './login-modal-wrapper-helper.component';

@Component({
  selector: 'idp-login-modal-wrapper',
  templateUrl: './login-modal-wrapper.component.html',
  styleUrls: ['./login-modal-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginModalWrapperComponent
  extends LoginModalWrapperHelperComponent
  implements OnChanges, OnInit
{
  @Output() hideModal = new EventEmitter();
  @Output() logOutAndShop = new EventEmitter();
  @Input() shouldcallservice!: string;
  @Input() fromApp!: string;
  @Input() fromProfileSelector!: string;
  @Input() fromStandAlonePage = false;
  @Input() centerPage = false;
  @Input() centerpage = false;
  @Input() redirectUrl!: string;
  @Input() redirecturl!: string;
  @Input() warmstate = false;
  @Input() callbackurl = '';
  @ViewChild('profileLoginWrapper') profileLoginWrapper!: ElementRef;
  loginStatus = false;
  isOpen = false;
  isRecognitionPage = false;
  // localTesting = true; // un-comment only for local testing and DO NOT COMMIT THIS CHANGE
  constructor(
    protected loginDasboardService: LoginDasboardService,
    protected loginUtilHelper: LoginHelperUtils,
    private coreUtilService: CoreUtilService,
    protected renderer: Renderer2,
    public profileSelectorFacadeService: ProfileSelectorFacadeService,
    protected loginModalService: LoginModalService
  ) {
    super(
      loginDasboardService,
      loginUtilHelper,
      renderer,
      profileSelectorFacadeService,
      loginModalService
    );
  }

  ngOnInit() {
    this.showLoginModal();
    if (this.loginUtilHelper.isRecognitionRoute()) {
      const isAccountType =
        !!this.coreUtilService.getAccountCookie('accountType');
      if (isAccountType) return;
      this.enableRecognitionLoginModal();
    }
  }

  enableRecognitionLoginModal() {
    this.isRecognitionPage = this.loginUtilHelper.recognitionRoute.value;
    this.shouldcallservice = 'true';
    this.displayLoginModal = true;
    this.displayProfileSelector = false;
    this.renderer.addClass(document.body, 'modal-open');
  }

  listenToEvents(changes: SimpleChanges) {
    if (this.fromApp) {
      document.addEventListener(
        'profile-selector-click',
        () => this.processProfileSelector() // TODO remove when all apps are using sitewide header
      );
      document.addEventListener('login-modal-click', () =>
        this.processLoginModal(changes)
      );
    }
  }

  processProfileSelector() {
    if (this.isOpen) {
      return;
    }
    this.getProfileSelectorDashboardData();
  }

  @HostListener('window:keydown.enter')
  public onKey() {
    this.onPageClick();
  }

  @HostListener('document:click')
  public onPageClick() {
    if (!this.fromApp) {
      const profileSelectorButton: HTMLElement | null =
        document.querySelector('.account-type');
      const elementTag: HTMLElement | null = document.querySelector(
        'idp-login-modal-profile-selector'
      );
      const fromprofileselectorValue = elementTag?.getAttribute(
        'fromprofileselector'
      );
      if (this.isOpen) {
        return;
      }
      if (
        this.checkForClickFromProfileSelector(
          profileSelectorButton,
          fromprofileselectorValue,
          this.fromApp
        )
      ) {
        this.getProfileSelectorDashboardData();
      }
    }
  }

  getProfileSelectorDashboardData() {
    this.isOpen = true;
    this.displayProfileSelector = true;
    this.openFlyOutToggle();
    this.renderer.removeClass(this.profileLoginWrapper.nativeElement, 'd-none');
    this.displayLoginModal = false;
    this.profileSelectorFacadeService.enableProfileSelector(false);
  }

  openFlyOutToggle() {
    const toggleFlyoutArrow = document.querySelector(
      '.account-type .account-details .open-flyout'
    ) as HTMLElement;
    if (toggleFlyoutArrow) {
      toggleFlyoutArrow.classList.replace('open-flyout', 'toggle-up');
      toggleFlyoutArrow.style.backgroundPosition = '50% 20%';
      toggleFlyoutArrow.style.paddingRight = 0.5 + 'rem';
      toggleFlyoutArrow.style.paddingLeft = 0.5 + 'rem';
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.fromApp) {
      this.listenToEvents(changes);
    } else if (this.checkForTriggerIsFromLoginModal(changes)) {
      if (this.checkForCenterPageLoginModal(changes)) {
        this.checkForRedirectUrl(changes);
        this.centerPage = true;
        this.enableCenterPageLoginModal(changes);
      }
      this.shouldcallservice = changes?.shouldcallservice.currentValue;
      this.displayLoginModal = true;
      this.displayProfileSelector = false;
    }
  }

  checkForRedirectUrl(changes: SimpleChanges) {
    if (changes && changes?.redirecturl && changes?.redirecturl.currentValue) {
      this.redirectUrl = changes.redirecturl.currentValue;
    }
  }

  checkForLoginButtonClickedForMainApp() {
    const loginModalDiv: HTMLElement | null =
      document.querySelector('.login-modal');
    if (
      this.checkForMakingBackendCallForMainApp(
        this.fromApp,
        loginModalDiv,
        this.shouldcallservice
      )
    ) {
      this.displayLoginModal = true;
      this.displayProfileSelector = false;
    }
  }

  onCloseProfileModal() {
    this.onCloseProfileModalHelper(this.profileLoginWrapper.nativeElement);
  }

  onCloseLoginModal() {
    this.loginModalService.isCenterLogin$.next(false);
    this.onCloseLoginModalHelper(this.profileLoginWrapper.nativeElement);
    this.centerpage = false;
    this.centerPage = false;
    this.hideModal.emit(true);
  }

  showLoginModal() {
    this.loginModalService.isCenterLogin$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((response) => {
        if (response) {
          this.centerPage = true;
          this.redirectUrl = this.loginModalService.redirectUrl;
          this.enableCenterPageLoginModal({} as SimpleChanges, 'checkout');
          this.displayLoginModal = true;
          this.displayProfileSelector = false;
        }
      });
  }
}
